import {  Component,OnDestroy, OnInit } from '@angular/core';
import { ProcesoReporte } from '../../../base/proceso-reporte';
import { AppComponent } from 'src/app/app.component';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { MenuItem, MessageService } from 'primeng/api';
import { FormBuilder } from '@angular/forms';
import { IHeader, Pdf } from 'src/app/clases/pdf';
import { XlsxService } from 'src/app/services/utils/xlsx.service';
import { restoreDashPattern } from 'pdf-lib';
import { CobrosRecuperadorService } from 'src/app/services/seguimiento/cobros-recuperadores.service';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-cobros-recuperador',
  templateUrl: './cobros-recuperador.component.html',
  styleUrls: ['./cobros-recuperador.component.scss']
})
export class CobrosRecuperadorComponent extends ProcesoReporte implements OnInit {
  grafico !: Highcharts.Chart | undefined | any;
  mostrarGrafico : boolean = false;
  totalDuracionLlamadas = 0;
  totalTiempoLlamada = 0;
  totalPromedio = 0;
  totalLlamadas = 0; 
  pantallaCompletaGrafico : boolean = false;
  //'MMIRANDA','ANOGUERA','LMONTIEL','NARCE','ALUGO'
  usuarios = [
    { nombre: 'MMIRANDA', valor: 'MMIRANDA' },
    { nombre: 'ANOGUERA', valor: 'ANOGUERA' },
    { nombre: 'LMONTIEL', valor: 'LMONTIEL' },
    { nombre: 'NARCE', valor: 'NARCE' },
    { nombre: 'ALUGO', valor: 'ALUGO' },
  ]

  recuperadores: Record< string, any >[] = [];
  resumenRecuperadores: Record< string, any >[] = [];
  datosAnteriores: Record< string, any >[] = [];
  estadosLlamada : Record< string, any >[]= [
    { nombre: 'Respondido', valor:'ANSWERED'},
    { nombre: 'Sin Respuesta', valor:'NO ANSWER'},
    { nombre: 'Ocupado', valor:'BUSY'},
    { nombre: 'Congestion', valor:'CONGESTION'},
  ]
  private colorPalette: string[] = [
    '#2ca02c', '#1f77b4', '#ff7f0e', '#d62728',
    '#9467bd', '#8c564b', '#e377c2', '#7f7f7f',
    '#bcbd22', '#17becf'
  ];
  private colorMap: { [label: string]: string } = {};
  private colorIndex = 0;
  todosLosEstados = [ 'ANSWERED', 'NO ANSWER', 'BUSY', 'CONGESTION' ]
  totalLlamadasRepetidas = 0;
  cobrosOriginales = [];
  TIPO_ENTIDAD = 'Entidades';
  TIPO_PAGO_FACIL = 'PagoFacil';
  totalCobrosPF = 0;
  totalCobrosEntidad = 0;
  totalCobros = 0;
  totalCantidadCobros = 0;
  mostrarCantidadRecuperadores = 0;

    opcionesImpresion: MenuItem[] = [
        {
          label: 'Resumido',
          command: () => this.descargar('resumido')
        },
        {
          label: 'Detallado',
          command: () => this.descargar('detallado')
        }
    ];
    responsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 1
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 1
      },
      {
        breakpoint: '560px',
        numVisible: 1,
        numScroll: 1
      }
    ];

  constructor(
    public app: AppComponent, 
    private breadcrumbService: AppBreadcrumbService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private xlsxService : XlsxService,
    private cobrosRecuperadorService: CobrosRecuperadorService,
    private currencyPipe : CurrencyPipe,
  ) {
    super();
    this.crearFormulario();
    this.breadcrumbService.setItems([ { label: 'Gestion de Cobros' } ]);
  }
  ngOnInit(): void {
    setTimeout(() => {
      this.setAllUsuarios();
    },200)
  }

  initializeChart() {
    const container = document.getElementById('chart-container') as HTMLElement;

    if (container) {
      this.grafico = Highcharts.chart(container, {
        chart: {
          type: 'column',
          animation: true,
          style: {
            fontSize: '1.3rem', 
          }
        },
        title: {
          text: 'Cobros por recuperador'
        },
        xAxis: {
          categories: [],
          title: {
            text: 'Cobrador'
          },
          labels: {
            rotation: 0,
          }
        },
        yAxis: {
          title: {
            text: 'Cobros en Gs.'
          },
          min: 0,
          labels: {
            formatter: function () {
              return new Intl.NumberFormat( 'es-PY' ).format( this.value as any ) + ' Gs.';
            }
          }
        },
        plotOptions: {
          column: {
            grouping: true,
            pointPadding: 0.2,
            borderWidth: 0, 
            maxPointWidth: 100, // 👉 Máximo ancho por barra
            dataLabels: {
              enabled: true,
              formatter: function () {
                return new Intl.NumberFormat( 'es-PY' ).format( this.y ) + ' Gs.';
              },
              style: {
                fontSize: '1.1rem',
                fontWeight: 'bold'
              },
            }
          }
        },
        tooltip: {
          pointFormatter: function () {
            return `<span style="color:${ this.color }">\u25CF</span> ${ this.series.name }: <b>${
              new Intl.NumberFormat( 'es-PY' ).format( this.y )
            } Gs.</b><br/>`;
          }
        },
        series: [
          {
            type: 'column',
            name: 'Total de Cobros en Gs.',
            data: [],
            color: '#1565C0',
          },
        ]
      });
    } else {
      console.error('No se encontró el contenedor con id "chart-container"');
    }
  }

  updateChartData() {
    const resumenFinal = this.items;
    const categorias = resumenFinal.map(item => item.usuario);

    const datosTotal = resumenFinal.map(item => ({
      y: item.totalImporte,
    }));

    if (this.grafico) {
      this.grafico.xAxis[0].setCategories(categorias);
      this.grafico.series[0].setData(datosTotal, false);

      this.grafico.redraw();
    }
  }

  async crearFormulario() {
    const hoy = new Date();
    const fechaDesde = new Date(hoy.getFullYear(), hoy.getMonth(), 1, 0, 0, 0); // 00:00:00
    const fechaHasta = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate(), 23, 59, 59); // 23:59:59
    
    this.formGroup = this.fb.group({
      fecha_desde: [fechaDesde],
      fecha_hasta: [fechaHasta],
      usuarios: [[]],
      nro_documento: '',
    });
  }

  async ejecutar(){
    this.items = [];
    
    const value = this.formGroup.getRawValue();
    try {    
        this.loading = true;
        this.items = []
        value['fecha_desde'] = this.datePipe.transform(value.fecha_desde, 'yyyy-MM-dd');
        value['fecha_hasta'] = this.datePipe.transform(value.fecha_hasta, 'yyyy-MM-dd');
        if( value['recuperadores'] === null ){ value['recuperadores'] = [] }
        let resPF : Record< string, any > = {};
        let resTech : Record< string, any > = {};
        //CONSULTA A PF
        try{
          resPF = await this.cobrosRecuperadorService.getCobrosRecuperadoresPagoFacil( value );
        } catch( error ) {
          this.messageService.add( {severity: 'info', summary: 'Ocurrio un error al consultar', detail: 'Algunos datos no se pudieron recuperar'});
          console.error(`Ocurrio un error en el base de datos de PF:`, error )
        }
        //CONSULTA A TECH
        try{
          resTech = await this.cobrosRecuperadorService.getCobrosRecuperadoresTech( value );
        } catch( error ) {
          this.messageService.add( {severity: 'info', summary: 'Ocurrio un error al consultar', detail: 'Algunos datos no se pudieron recuperar'});
          console.error(`Ocurrio un error en el base de datos de PF:`, error )
        }
        //SI EXISTEN DATOS DE PF LO AGREGAMOS
        if( resPF?.resp?.length > 0 && resPF.resp ) { 
          this.items = [...this.items, ...resPF.resp];
        } 
        //SI EXISTEN DATOS DE TECH LO AGREGAMOS
        if( resTech?.resp?.length > 0 && resTech.resp ) { 
          this.items = [ ...this.items, ...resTech.resp ];
        } 
        if( this.items.length < 1 ){
          this.messageService.add( {severity: 'info', summary: 'Sin resultados', detail: 'No se encontraron cobros'});
        } else if( this.items.length > 0 ){
          this.cobrosOriginales = this.items;
          await this.agruparCobrosPorUsuario( this.items );
          await this.obtenerCantidadRecuperadores();
          this.mostrarGrafico = true;
          setTimeout( async () =>{
            await this.initializeChart();
            await this.updateChartData();
          },200)
        }
        this.loading = false;
    } catch (error: any) {
        this.messageService.add({severity: 'error', 'summary': 'Ocurrio un error al traer los cobros'})
        console.error( error )
        this.loading = false;
    }
  }


  getColorForLabel(label: string): string {
    if (this.colorMap[label]) {
      return this.colorMap[label];
    }

    const color = this.colorPalette[this.colorIndex % this.colorPalette.length];
    this.colorMap[label] = color;
    this.colorIndex++;

    return color;
  }


  async setAllUsuarios(){
    for ( const usuario of this.usuarios ){
      const usuarios =  [ ...this.formGroup.get('usuarios').value ]
      usuarios.push( usuario.nombre )
      this.formGroup.get('usuarios').setValue( usuarios );
    }
  }

  async agruparCobrosPorUsuario(cobros: Record<string, any>[]): Promise<void> {
    this.totalCobrosPF = 0;
    this.totalCobrosEntidad = 0;
    this.totalCobros = 0;
    this.totalCantidadCobros = 0;

    const usuariosForm: string[] = this.formGroup.getRawValue().usuarios || [];
    const cobrosAgrupados: Record<string, any> = {};
    usuariosForm.forEach( usuario => {
        cobrosAgrupados [ usuario ] = {
          usuario,
          totalImportePagoFacil: 0,
          totalImporteEntidad: 0,
          detallesCobros: [],
          cantidadCobros: 0,
          totalImporte: 0,
          color1: this.getColorForLabel(usuario),
          color2: this.shadeColor(this.getColorForLabel(usuario), 40),
        };
    });
    for (const cobroActual of cobros) {
        const usuario = cobroActual.nom_usuario.trim();;
        if (!cobrosAgrupados[ usuario ]) {
            cobrosAgrupados[ usuario ] = {
                usuario,
                totalImportePagoFacil: 0,
                totalImporteEntidad: 0,
                detallesCobros: [],
                cantidadCobros: 0,
                totalImporte: 0,
                color1: this.getColorForLabel(usuario),
                color2: this.shadeColor(this.getColorForLabel(usuario), 40),
            };
        }
        cobrosAgrupados[usuario].detallesCobros.push(cobroActual);
        if (cobroActual.tipo === this.TIPO_PAGO_FACIL) {
          cobrosAgrupados[usuario].totalImportePagoFacil += Number(cobroActual.importe_cobrado);
          this.totalCobrosPF += Number(cobroActual.importe_cobrado);
        }

        if (cobroActual.tipo === this.TIPO_ENTIDAD) {
          cobrosAgrupados[usuario].totalImporteEntidad += Number(cobroActual.importe_cobrado);
          this.totalCobrosEntidad += Number(cobroActual.importe_cobrado);
        }
        cobrosAgrupados[usuario].totalImporte += Number(cobroActual.importe_cobrado);
        cobrosAgrupados[usuario].cantidadCobros += 1;
        this.totalCantidadCobros += 1;
        this.totalCobros += Number(cobroActual.importe_cobrado);
    }
    // Limpiar y sobreescribir el array original con los agrupados
    cobros.length = 0;
    cobros.push(...Object.values(cobrosAgrupados));
    }

  async descargar( formato: string ) {
      const pdf = new Pdf(this.currentUser);
      const value = this.formGroup.getRawValue();
      pdf.title = 'INFORME DE COBROS POR RECUPERADOR';
      pdf.headers = [
          { label: 'Usuario', name: 'usuario', type: 'text' },
          { label: 'Cantidad de Cobros', name: 'cantidadCobros', type: 'number' },
          { label: 'Total de Importe - Pago Facil', name: 'totalImportePagoFacil', type: 'number' },
          { label: 'Total de Importe - Entidad', name: 'totalImporteEntidad', type: 'number' },
          { label: 'Total de Importe ', name: 'totalImporte', type: 'number' },
      ]
        for (const item of this.items) {
            item.detallesCobros = item.detallesCobros.map(( cobro: any) => {
            return {
                ...cobro,
              };
            });

            let items = null;
            if( formato === 'detallado' ) {
              items = {
                    headers: [
                        { label: 'Nro Documento', name: 'nro_documento', type: 'text' },
                        { label: 'Fecha Cobro', name: 'fecha_cobro', type: 'date' },
                        { label: 'Tipo', name: 'tipo', type: 'text' },
                        { label: 'Entidad', name: 'nombre_entidad', type: 'text' },
                        { label: 'Nro Operacion', name: 'nro_operacion', type: 'text' },
                        { label: 'Importe Cobrado', name: 'importe_cobrado', type: 'text' },
                    ] as IHeader[],
                    source: item.detallesCobros as Record< string, any >[],
                }
            } 
            pdf.addSource({ 
                data: item,
                items: items,
            });
        }
        const totales = {
          totalPF : this.totalCobrosPF,
          totalEntidad : this.totalCobrosEntidad,
          totalCobros : this.totalCobros,
          cantidadCobros: this.totalCantidadCobros,          
        } 
        pdf.foot = {
            headers: [
                { label: 'Cantidad total de Cobros', name: 'cantidadCobros', type: 'number' },
                { label: 'Total de Cobros - Pago Facil', name: 'totalPF', type: 'number' },
                { label: 'Total de Cobros - Entidades', name: 'totalEntidad', type: 'number' },
                { label: 'Total de Cobros', name: 'totalCobros', type: 'number' },
            ],
            source: totales,
        }
      pdf.exportar();
  }
  async descargarExcel() {
      const datos: Record<string, any>[] = [];
      const value = this.formGroup.getRawValue();
      for (const item of this.items) {
        for( const cobro of item.detallesCobros ){
          datos.push({
            'Usuario': item.usuario,
            'Nro Documento': cobro.nro_documento,
            'Fecha de Cobro': this.datePipe.transform( cobro.fecha_cobro, 'dd/MM/yyyy' ),
            'Tipo': cobro.tipo,
            'Entidad': cobro.nombre_entidad,
            'Nro Operacion': cobro.nro_operacion,
            'Importe Cobrado': cobro.importe_cobrado,
          })
        }
      }
      await this.xlsxService.exportAsExcelFile(datos, `cobros_recuperadores_${ this.datePipe.transform(value.fecha_desde, 'dd/MM/yyyy')}-${ this.datePipe.transform(value.fecha_hasta, 'dd/MM/yyyy')}`);
  }

  mostrarGraficoCompleto( mostrar : boolean ){
    this.pantallaCompletaGrafico = mostrar;
  }

  formatearGs( valor ) { 
    return valor.toString() 
  }

  shadeColor(color: string, percent: number): string {
    let R = parseInt(color.substring(1, 3), 16);
    let G = parseInt(color.substring(3, 5), 16);
    let B = parseInt(color.substring(5, 7), 16);

    R = Math.min(255, Math.max(0, Math.round(R + (R * percent / 100))));
    G = Math.min(255, Math.max(0, Math.round(G + (G * percent / 100))));
    B = Math.min(255, Math.max(0, Math.round(B + (B * percent / 100))));

    const RR = R.toString(16).padStart(2, '0');
    const GG = G.toString(16).padStart(2, '0');
    const BB = B.toString(16).padStart(2, '0');

    return `#${RR}${GG}${BB}`;
  }

  async obtenerCantidadRecuperadores( ){
    if( this.items.length > 2 ){
      this.mostrarCantidadRecuperadores = 3;
    } else {
      this.mostrarCantidadRecuperadores = this.items.length;
    }
  }
}
